module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/payoneer-48fea996ba44eb75521c121004de2616.png";